"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * TS does not create reverse mappings for string enums...
 *
 * This does what enum[val] will not.
 *
 * @param en
 */
exports.findEnumByString = function (en) { return function (possible) { return lodash_1.reduce(lodash_1.keys(en), function (match, key) {
    return !match && en[key] === possible ? en[key] : match;
}, undefined); }; };
exports.enumContainsString = function (en) { return function (possible) { return lodash_1.flow(exports.findEnumByString(en), function (match) { return match !== undefined; })(possible); }; };
//# sourceMappingURL=findEnumByString.js.map